import dayjs from "dayjs";
import excel from "exceljs";
import type { PAPart } from "@/api/PAService";
import { triggerDownload } from "./sheetHelpers";

const HEADERS = [
  { header: "PA Part ID", key: "pa_part_id", width: 14 },
  { header: "PA Supplier ID", key: "pa_supplier_id", width: 16 },
  { header: "Supplier Code", key: "supplier_code", width: 16 },
  { header: "Part No", key: "part_no", width: 18 },
  { header: "Part Name", key: "part_name", width: 28 },
  { header: "AC", key: "ac", width: 10 },
  { header: "Routing", key: "routing", width: 12 },
  { header: "Production", key: "production_proposed", width: 14 },
  { header: "Service", key: "service_proposed", width: 12 },
  { header: "Tooling", key: "tooling_proposed", width: 12 },
  { header: "PA No", key: "pa_no", width: 18 },
  { header: "Confirmation No", key: "confirmation_no", width: 20 },
  { header: "Result", key: "result", width: 12 },
  { header: "Effective Date", key: "part_effective_date", width: 16 },
  { header: "Reason", key: "reason", width: 20 },
  { header: "Note", key: "note", width: 20 },
  { header: "Created Date", key: "create_date", width: 20 },
  { header: "Updated Date", key: "update_date", width: 20 },
];

const HEADER_FILL: excel.Fill = {
  type: "pattern",
  pattern: "solid",
  fgColor: { argb: "FF00A8A9" },
};

const HEADER_FONT: Partial<excel.Font> = {
  bold: true,
  color: { argb: "FFFFFFFF" },
};

const THIN_BORDER: Partial<excel.Borders> = {
  top: { style: "thin" },
  left: { style: "thin" },
  bottom: { style: "thin" },
  right: { style: "thin" },
};

const applyBorder = (row: excel.Row) => {
  row.eachCell({ includeEmpty: true }, (cell) => {
    cell.border = THIN_BORDER;
  });
};

export const exportPAPartToExcel = async (rows: PAPart[]) => {
  const workbook = new excel.Workbook();
  const sheet = workbook.addWorksheet("PA Part");

  sheet.columns = HEADERS;

  const headerRow = sheet.getRow(1);
  headerRow.eachCell((cell) => {
    cell.fill = HEADER_FILL;
    cell.font = HEADER_FONT;
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = THIN_BORDER;
  });
  headerRow.height = 22;

  for (const item of rows) {
    const row = sheet.addRow({
      pa_part_id: item.pa_part_id,
      pa_supplier_id: item.pa_supplier_id,
      supplier_code: item.supplier_code ?? "",
      part_no: item.part_no,
      part_name: item.part_name,
      ac: item.ac ?? "",
      routing: item.routing ?? "",
      production_proposed: item.production_proposed,
      service_proposed: item.service_proposed,
      tooling_proposed: item.tooling_proposed,
      pa_no: item.pa_no ?? "",
      confirmation_no: item.confirmation_no ?? "",
      result: item.result ?? "",
      part_effective_date: item.part_effective_date
        ? dayjs(item.part_effective_date).format("DD/MM/YYYY")
        : "",
      reason: item.reason ?? "",
      note: item.note ?? "",
      create_date: item.create_date
        ? dayjs(item.create_date).format("DD/MM/YYYY HH:mm")
        : "",
      update_date: item.update_date
        ? dayjs(item.update_date).format("DD/MM/YYYY HH:mm")
        : "",
    });
    applyBorder(row);
  }

  const fileName = `PA_Part_${dayjs().format("YYYYMMDD_HHmmss")}`;
  triggerDownload(await workbook.xlsx.writeBuffer(), fileName);
};
